module.exports = __webpack_public_path__ + "img/Illustration-08.9252a41f.png";